var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00029 6.83358L9.39462 9.54904C9.82254 9.89137 10.4463 9.82554 10.7933 9.40141L17.667 1.00024",
    stroke: "#6CE660",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.200195 7.0661C0.531601 6.62481 1.15894 6.5349 1.60059 6.86591L4.16699 8.79071L4.34668 8.57001L5.88281 9.85126L5.71484 10.0573C5.0362 10.8868 3.82418 11.0343 2.9668 10.3913L0.400391 8.46649C-0.0413285 8.13511 -0.131104 7.50789 0.200195 7.0661ZM11.0596 0.366882C11.4092 -0.0599516 12.0395 -0.123872 12.4668 0.225281C12.8939 0.574747 12.9572 1.20509 12.6084 1.63251L9.0498 5.98016L7.51367 4.69989L11.0596 0.366882Z",
    fill: "#6CE660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.6b2c06f79351ea2bdf69a8f2d3d1bdae.svg";
export { ForwardRef as ReactComponent };